import { User } from 'apis/types';

export const displayName = (user: User): string => {
    return user.username || user.email || '';
};
